/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the RecordingDurationBucket interface.
 */
export function instanceOfRecordingDurationBucket(value) {
    if (!('count' in value) || value['count'] === undefined)
        return false;
    if (!('max' in value) || value['max'] === undefined)
        return false;
    if (!('p50' in value) || value['p50'] === undefined)
        return false;
    if (!('p90' in value) || value['p90'] === undefined)
        return false;
    if (!('p95' in value) || value['p95'] === undefined)
        return false;
    if (!('p99' in value) || value['p99'] === undefined)
        return false;
    return true;
}
export function RecordingDurationBucketFromJSON(json) {
    return RecordingDurationBucketFromJSONTyped(json, false);
}
export function RecordingDurationBucketFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'count': json['count'],
        'max': json['max'],
        'p50': json['p50'],
        'p90': json['p90'],
        'p95': json['p95'],
        'p99': json['p99'],
    };
}
export function RecordingDurationBucketToJSON(json) {
    return RecordingDurationBucketToJSONTyped(json, false);
}
export function RecordingDurationBucketToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'count': value['count'],
        'max': value['max'],
        'p50': value['p50'],
        'p90': value['p90'],
        'p95': value['p95'],
        'p99': value['p99'],
    };
}
